import { IMonth } from 'common/types';
import {
  BudgetValueState,
  IBudget,
  IBudgetPeriod
} from '../../common/entities';

function isActivePeriod(period: IBudgetPeriod) {
  const currDate = new Date();
  return (
    period.year === currDate.getFullYear() &&
    period.month === currDate.getMonth()
  );
}

export function hasActivePeriod(budget: IBudget) {
  return budget.periods && budget.periods.some(p => isActivePeriod(p));
}

export function hasPeriod(budget: IBudget, period: IMonth) {
  return (
    budget.periods &&
    budget.periods.some(p => p.year === period.year && p.month === period.month)
  );
}

export function getActivePeriod(budget: IBudget) {
  const savedPeriod = budget.periods?.find(p => isActivePeriod(p));
  return savedPeriod ?? getCurrentPeriod(budget);
}

export function getMonthPeriod(
  budget: IBudget,
  month: IMonth
): IBudgetPeriod | undefined {
  return budget.periods?.find(
    p => p.year === month.year && p.month === month.month
  );
}

export function getCurrentPeriod(budget: IBudget): IBudgetPeriod {
  const currDate = new Date();
  return {
    year: currDate.getFullYear(),
    month: currDate.getMonth(),
    budget: budget.defaultBudget
  };
}

export const getMonthBudgetTotal = (
  selectedBudgets: IBudget[],
  monthBudgets: Record<string, BudgetValueState>
) =>
  selectedBudgets.reduce(
    (sum, current) =>
      monthBudgets[current.id]?.selected
        ? sum + (monthBudgets[current.id].value ?? 0)
        : sum,
    0
  );
